import { useMemo } from "react";
import { Source, Layer } from "react-map-gl/mapbox";
import type { FeatureCollection, LineString } from "geojson";

const SOURCE_ID = "route-track-source";
const HALO_LAYER_ID = "route-track-halo-layer";
const LAYER_ID = "route-track-layer";

interface RouteTrackLayerProps {
  track: GeoJSON.LineString | null | undefined;
}

/**
 * Renders a route track as a line on the map.
 * Always renders (with empty features when no track) to maintain consistent layer ordering.
 */
export function RouteTrackLayer({ track }: RouteTrackLayerProps) {
  const data = useMemo((): FeatureCollection<LineString> => {
    if (!track) {
      return { type: "FeatureCollection", features: [] };
    }
    return {
      type: "FeatureCollection",
      features: [{ type: "Feature", geometry: track, properties: {} }],
    };
  }, [track]);

  return (
    <Source id={SOURCE_ID} type="geojson" data={data}>
      <Layer
        id={HALO_LAYER_ID}
        type="line"
        paint={{
          "line-color": "#536600",
          "line-width": ["interpolate", ["exponential", 1.5], ["zoom"], 0, 2, 12, 10, 18, 24],
          "line-opacity": 0.3,
        }}
      />
      <Layer
        id={LAYER_ID}
        type="line"
        paint={{
          "line-color": "#536600",
          "line-width": ["interpolate", ["exponential", 1.5], ["zoom"], 0, 1, 12, 2, 18, 5],
          "line-opacity": 1,
        }}
      />
    </Source>
  );
}
